  import React, { useState } from 'react';
  import * as S from './styles';
  import { AnchorSelectBox } from '../../../../../components/AnchorSelectBox';
  
  function AnchorsLogoOptions({ 
    valoresOpcoes,
    selectedAnchor,
    title,
    filterName,
    handleInputChange,
    isLoading,
    ordem,
    conteudoOnChange,
    disabledList,
    componenteWidth,
}) {
    const [anchorsModal, setAnchorsModal] = useState({
      show: false,
      callback: () => {},
      anchors: [],
      newSelectedAnchor: {},
      closeModal: () => {}
    })

    const handleSelecteAnchor = (anchor) => {
        handleInputChange(ordem, anchor, conteudoOnChange);
      closeModal()
    }

    const closeModal = () => {
      setAnchorsModal({
        show: false,
        callback: () => {},
        anchors: [],
        newSelectedAnchor: {},
        closeModal: () => {}
      })
    }

    return (
      <>
        <S.MetasBox style={{width: componenteWidth == 0 ? 200 : componenteWidth}}>
          <S.TableTitleHeader>
            <h3 className="operation-title text-center">Plataformas/Redes</h3>
          </S.TableTitleHeader>
          <S.MetasContainer>
            <S.AnchorLogo onClick={() => {
              if ((valoresOpcoes[ordem]?.redes?.length > 0
                || valoresOpcoes[ordem]?.redeCapittale?.ancoraId
                || valoresOpcoes[ordem]?.plataformas?.length > 0
                || valoresOpcoes[ordem]?.length > 0) && !(isLoading || disabledList[ordem])) {

              }
              setAnchorsModal({
                show: true,
                callback: handleSelecteAnchor,
                anchors: valoresOpcoes[ordem],
                newSelectedAnchor: selectedAnchor,
                closeModal: closeModal
              })
            }}>
              {selectedAnchor?.logotipoLink ? (
                <img
                style={{ objectFit: 'contain', background: 'white' }}
                src={selectedAnchor?.logotipoLink}
                alt={`Logo da rede ${selectedAnchor?.nomeFantasia ? selectedAnchor?.nomeFantasia : selectedAnchor?.plataforma}`}
              />
              ) : (
                <div style={{cursor: 'pointer'}}>
                {selectedAnchor?.nomeFantasia ? selectedAnchor?.nomeFantasia : selectedAnchor?.plataforma}
                </div>
              )}
            </S.AnchorLogo>
          </S.MetasContainer>
        </S.MetasBox>
        {anchorsModal.show && (
          <AnchorSelectBox
            data={anchorsModal}
          ></AnchorSelectBox>
        )}
      </>
    );
  }
  
  export default AnchorsLogoOptions;
  